import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConveyorChainClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 240,
	height: 80,
	viewBox: "0 0 240.0 80.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 240,
			height: 80,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45,
			y: 15,
			width: 150,
			height: 50,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45,
			cy: 40,
			rx: 25,
			ry: 25,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 195,
			cy: 40,
			rx: 25,
			ry: 25,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		})
	]
});
export default SvgConveyorChainClosed;
